export default __webpack_public_path__ + "assets/icons/de.3d63838d.svg";